import SectionLabel from "@/components/base/SectionLabel";
import { businessToolData } from "@/mocks/businessToolData";

export default function PricingSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="pricing" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-14 md:mb-18 reveal">
          <SectionLabel
            label={businessToolData.pricing.label}
            className="mb-3"
          />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {businessToolData.pricing.title}
          </h2>
        </div>

        <div className="max-w-lg mx-auto reveal">
          <div className="rounded-lg bg-primary-500/[0.06] border-2 border-primary-300/60 p-7 md:p-9">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-code-s-slash-line text-background-50 text-xl" />
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-bold text-foreground-900 font-heading">
                  {businessToolData.pricing.planName}
                </h3>
              </div>
            </div>

            <p className="text-2xl md:text-3xl font-bold text-primary-600 font-heading mb-2">
              {businessToolData.pricing.pricing}
            </p>
            <p className="text-xs text-foreground-500 mb-5">
              {businessToolData.pricing.description}
            </p>

            <div className="mb-6">
              <p className="text-xs font-medium text-foreground-500 font-label mb-2">
                見積りに含まれる主な項目
              </p>
              <ul className="space-y-2">
                {businessToolData.pricing.estimateItems.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="border-t border-primary-200/40 pt-4 mb-5">
              <p className="text-xs font-medium text-foreground-500 font-label mb-2">
                料金が決まる主な要素
              </p>
              <div className="grid grid-cols-2 gap-x-3 gap-y-1.5">
                {businessToolData.pricing.priceFactors.map((factor) => (
                  <div key={factor} className="flex items-start gap-1.5 text-xs text-foreground-600">
                    <span className="w-1 h-1 rounded-full bg-secondary-400 mt-1.5 flex-shrink-0" />
                    {factor}
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-5 bg-background-50 rounded-md p-3 border border-background-200/50">
              <div className="flex items-start gap-2">
                <i className="ri-information-line text-primary-500 mt-0.5 flex-shrink-0 text-sm" />
                <p className="text-xs text-foreground-600 leading-relaxed font-bold">
                  {businessToolData.pricing.note}
                </p>
              </div>
            </div>

            <button
              onClick={scrollToContact}
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {businessToolData.pricing.cta}
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}